import { useState } from 'react';
import { safeParseConfig } from '../blockConfig';

const DEFAULT = { words: [], errorWordIndex: 0 };

// Same "type the whole sentence, we split it" idea as SentenceOrderEditor -
// then the teacher clicks which of the resulting words IS the error,
// directly on the same word chips the student will eventually see and tap.
export default function ErrorSpottingEditor({ block, onSave, onCancel }) {
   const initial = safeParseConfig(block.config, DEFAULT);
   const [sentence, setSentence] = useState(initial.words && initial.words.length ? initial.words.join(' ') : '');
   const [errorIndex, setErrorIndex] = useState(initial.errorWordIndex || 0);

   const words = sentence.trim() ? sentence.trim().split(/\s+/) : [];
   const clampedErrorIndex = Math.min(errorIndex, Math.max(0, words.length - 1));

   const handleSave = () => onSave({ text: sentence, config: JSON.stringify({ words, errorWordIndex: clampedErrorIndex }) });

   return (
      <div className='exercise-block-generic-editor'>
         <textarea className='exercise-block-generic-text' rows={2} value={sentence}
            placeholder='Речення з однією помилкою, напр: She go to school every day'
            onChange={e => setSentence(e.target.value)} />
         {words.length > 0 ? (
            <>
               <p className='exercise-block-hint-text'>Натисни на слово, яке є помилкою:</p>
               <div className='exercise-block-error-spotting-words'>
                  {words.map((w, i) => (
                     <span key={i} className={'exercise-block-error-word-chip' + (i === clampedErrorIndex ? ' selected' : '')}
                        onClick={() => setErrorIndex(i)}>
                        {w}
                     </span>
                  ))}
               </div>
            </>
         ) : ''}
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderErrorSpottingPreview(block) {
   const cfg = safeParseConfig(block.config, DEFAULT);
   if(!cfg.words || cfg.words.length === 0) return <span className='exercise-block-empty-hint'>Порожньо</span>;
   return (
      <p className='exercise-block-text-preview'>
         {cfg.words.map((w, i) => i === cfg.errorWordIndex ? <u key={i}>{w} </u> : w + ' ')}
      </p>
   );
}
